import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { IoClose } from "react-icons/io5";
import { Box } from '@mui/material';


function formatDate(dateString) {
    const date = new Date(dateString);

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;

    return `${formattedDate}`;
  }

  function formatTime(dateString) {
    const date = new Date(dateString);
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedTime = `${formattedHours}:${minutes}:${seconds} ${ampm}`;
    return `${formattedTime}`;
  }

export default function MappingDialog(props) {
 
    console.log("props",props);
    
  return (
    <React.Fragment>
      
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="xs"
      >
        <Box sx={{position:'absolute',top:5,right:5,cursor:'pointer',fontSize:'25px'}} onClick={props.handleClose}>
            <IoClose />
        </Box>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <table>
                <tr style={{padding:'5px'}}>
                    <th style={{textAlign:'left',padding:'5px'}}>DS Name</th>
                    <td>:</td>
                    <td>{props.open?props.open.ds_details.username:''}</td>
                </tr>
                <tr style={{padding:'5px'}}>
                    <th style={{textAlign:'left',padding:'5px'}}>DS Id</th>
                    <td>:</td>
                    <td>{props.open?props.open.ds_details.usercode:''}</td>
                </tr>
                <tr style={{padding:'5px'}}>
                    <th style={{textAlign:'left',padding:'5px'}}>Requested date & time</th>
                    <td>:</td>
                    <td>{props.open?formatDate(props.open.ds_requested_at)+"/"+formatTime(props.open.ds_requested_at):''}</td>
                </tr>
            </table>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{display:'flex',justifyContent:'center'}}>
            <Button variant='contained' color='secondary' onClick={()=>props.handleViewRequest(props.open)}>View Request</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
